import { useState, useEffect } from 'react';

const SafeBg = ({ src, className = '', style = {}, children, onClick, onError: onErrorCallback }) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!src) { setStatus('error'); onErrorCallback?.(); return; }
    setStatus('loading');
    const img = new Image();
    img.onload = () => setStatus('loaded');
    img.onerror = () => { setStatus('error'); onErrorCallback?.(); };
    img.src = src;
    return () => { img.onload = null; img.onerror = null; };
  }, [src]);

  return (
    <div
      className={`${className}${status === 'error' ? ' bg-neutral' : ''}`}
      style={{
        ...style,
        backgroundImage: status === 'loaded' ? `url(${src})` : undefined,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default SafeBg;
